import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const UTM_KEY = "hstc_utms";

// First-touch attribution: capture utm_source / utm_campaign from the URL
// the first time we see them, and keep them until checkout.
export function captureUtms() {
  try {
    const p = new URLSearchParams(window.location.search);
    const source = p.get("utm_source");
    const campaign = p.get("utm_campaign");
    if (!source && !campaign) return;
    const existing = JSON.parse(localStorage.getItem(UTM_KEY) || "{}");
    if (existing.utm_source || existing.utm_campaign) return; // keep first touch
    localStorage.setItem(UTM_KEY, JSON.stringify({
      utm_source: source || "",
      utm_campaign: campaign || "",
    }));
  } catch { /* ignore */ }
}

export function getStoredUtms() {
  try {
    const u = JSON.parse(localStorage.getItem(UTM_KEY) || "{}");
    return { utm_source: u.utm_source || "", utm_campaign: u.utm_campaign || "" };
  } catch {
    return { utm_source: "", utm_campaign: "" };
  }
}
